import { useContext, useRef } from "react";
import { createPortal } from "react-dom";
import { createTab, getDailyList } from "../CommonFunc";
import "./AddDiary.scss";
import { useQuery } from "../../Site/effects";
import { AppContext } from "../../Context/AppContext";
function AddDiary(props) {
	const { theme } = useContext(AppContext);
	const inputRef = useRef();
	const query = useQuery();
	const hadleCreate = () => {
		createTab(inputRef.current.value).then((result) => {
			getDailyList(query.get("isNew") ?? 1).then((diarys) => {
				props.setDiarys(diarys);
				props.setCurrentDiary(
					diarys.find((item) => item.ID === result[0].NEW_ID) ?? []
				);
			});
		});
		props.setOpenAddDiary(false);
		window.addDiaryFlag = true;
	};
	return createPortal(
		<div
			className='add-diary-dialog-wrapper'
			color={theme.color}
			style={{
				fontSize: `${18 * theme.fontMultiplier}px`,
			}}
		>
			<div className='add-diary-dialog'>
				<input
					ref={inputRef}
					className='name-field'
					type='text'
					placeholder='Имя дневника'
					defaultValue={""}
					autoFocus
				/>
				<div className='create-button' onClick={() => hadleCreate()}>
					Создать
				</div>
				<div
					className='close-button'
					onClick={() => props.setOpenAddDiary(false)}
				>
					Закрыть
				</div>
			</div>
		</div>,
		document.getElementById("addDiary")
	);
}

export default AddDiary;
